/* Course */
export const GET_COURSE = "GET_COURSE"
export const GET_COURSE_SUCCESS = "GET_COURSE_SUCCESS"
export const GET_COURSE_CLEAN = "GET_COURSE_CLEAN"
export const API_ERROR = "API_ERROR"
export const GET_COURSE_USER = "GET_COURSE_USER"
export const GET_COURSE_USER_SUCCESS = "GET_COURSE_USER_SUCCESS"
export const GET_COURSE_USER_CLEAN = "GET_COURSE_USER_CLEAN"
export const GET_COURSE_USER_ERROR = "GET_COURSE_USER_ERROR"